import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './Admin.css';
import {
    Container,
} from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import SystemCompanies from './SystemCompanies';
import * as utilities from '../../utilities';
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';
class SystemCompaniesContainer extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.blankSystemCompany = {
            companySettingsID: 0,
            companyName: '',
            // companyDatabase: '',
            companyLogo: '',
            companyUseSECData: false,
            companyActive: 1,
        }
        this.state = {
            systemCompanies: [],
            newSystemCompany: { ...this.blankSystemCompany },
            editSystemCompany: { ...this.blankSystemCompany },
            isLoaded: 0,
            unsavedChanges: false,
            isAdding: false
        };
    }

    componentDidMount() {
        this.getSystemCompanies();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getSystemCompanies = () => {
        fetch('/api/systemCompanies/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    isLoaded: 1,
                    systemCompanies: results.data
                });
            });
    }

    handleAddSystemCompany = (e) => {
        this.setState({
            isAdding: true
        }, () => {
            const rawCompanyName = (this.state.newSystemCompany.companyName).trim();
            if (rawCompanyName.length < 4) {
                return utilities.addToast('Company name is too short.', 5, 'danger');
            }
            fetch('/api/systemCompanies/', {
                method: 'POST',
                body: JSON.stringify({
                    companyName: rawCompanyName,
                    companyDisplayName: this.state.newSystemCompany.companyDisplayName,
                    companyPortalDatabase: this.state.newSystemCompany.companyPortalDatabase,
                    // companyDatabase: this.state.newSystemCompany.companyDatabase,
                    companyLogo: this.state.newSystemCompany.companyLogo,
                    companyUseSECData: this.state.newSystemCompany.companyUseSECData,
                    companyActive: this.state.newSystemCompany.companyActive,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.data) {
                        const sanitizedName = rawCompanyName
                            .replace(/[^\w\s-]/g, '')     // keep word chars, space, dash
                            .replace(/[\s-]+/g, '_')      // collapse spaces/dashes to underscore
                            .trim();
                        const newDatabase = `CRM_${sanitizedName}`;
                        this.props?.getCompanySettings();
                        fetch('/api/auth/', {
                            method: 'POST',
                            body: JSON.stringify({
                                // email: this.state.newUser.emailAddress,
                                // firstName: this.state.newUser.firstName,
                                // lastName: this.state.newUser.lastName,
                                // name: this.state.newUser.firstName + ' ' + this.state.newUser.lastName,
                                companyDatabase: newDatabase,
                                companyName: this.state.newSystemCompany.companyName,
                            }),
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.props.clientToken,
                                'X-Database': this.context.company
                            }
                        })
                            .then(results => results.json())
                            .then(results => {
                                if (results.success) {
                                    this.setState({
                                        isLoaded: 0,
                                        unsavedChanges: false
                                    }, async () => {
                                        await this.props.getToken(true);
                                        utilities.addToast('Company successfully added. Please logout and login again for changes to take effect.', 120, 'success');
                                        this.getSystemCompanies();
                                    })
                                } else {
                                    utilities.addToast('Unable to add user into company.', 5, 'danger')
                                }
                            })
                            .catch(() => {
                                utilities.addToast('An error has occurred.', 5, 'danger');
                            })
                    } else {
                        utilities.addToast('Unable to add company.', 5, 'danger')
                    }
                })
                .catch(() => {
                    utilities.addToast('An error has occurred.', 5, 'danger');
                })
                .finally(() => {
                    this.setState({
                        isAdding: false
                    })
                })
        })
    }


    onEditSystemCompany = (companySettingsID) => {
        const systemCompany = [...this.state.systemCompanies].filter(item => item.CompanySettingsID === companySettingsID)[0];
        this.setState({
            editSystemCompany: {
                companySettingsID: systemCompany.CompanySettingsID,
                companyName: systemCompany.CompanyName,
                companyDisplayName: systemCompany.CompanyDisplayName,
                companyPortalDatabase: systemCompany.CompanyPortalDatabase,
                // companyDatabase: systemCompany.CompanyDatabase,
                companyLogo: systemCompany.CompanyLogo,
                companyUseSECData: systemCompany.CompanyUseSECData,
                companyActive: systemCompany.CompanyActive,
            }
        })
    }

    handleDeleteSystemCompany = (id) => {
        fetch('/api/systemCompanies/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    this.setState({
                        editSystemCompany: { ...this.blankSystemCompany },
                        unsavedChanges: false
                    }, () => {
                        this.props?.getCompanySettings();
                        this.getSystemCompanies();
                    });
                }
            });
    }

    onChangeSystemCompany = (e, type) => {
        e.persist();
        const { name, type: inputType, value, files, checked } = e.target;

        if (name === 'companyLogo' && files && files[0]) {
            const file = files[0];
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64 = reader.result.split(',')[1]; // Strip metadata prefix
                this.setState(prevState => {
                    const thisSystemCompany = {
                        ...(type === 'edit' ? prevState.editSystemCompany : prevState.newSystemCompany),
                        companyLogo: base64
                    };

                    return type === 'edit'
                        ? { editSystemCompany: thisSystemCompany, unsavedChanges: true }
                        : { newSystemCompany: thisSystemCompany, unsavedChanges: true };
                });
            };

            reader.readAsDataURL(file); // Triggers onloadend
            return;
        }

        this.setState((prevState) => {
            let thisSystemCompany = (type === 'edit')
                ? { ...prevState.editSystemCompany }
                : { ...prevState.newSystemCompany };

            if (inputType === 'checkbox') {
                thisSystemCompany[name] = checked;
            } else {
                thisSystemCompany[name] = value;
            }

            return (type === 'edit')
                ? {
                    editSystemCompany: thisSystemCompany,
                    unsavedChanges: true
                }
                : {
                    newSystemCompany: thisSystemCompany,
                    unsavedChanges: true
                };
        });
    }

    handleCancelSystemCompany = () => {
        this.setState({
            editSystemCompany: { ...this.blankSystemCompany },
            unsavedChanges: false
        })
    }

    handleEditSystemCompany = () => {
        fetch('/api/systemCompanies/' + this.state.editSystemCompany.companySettingsID, {
            method: 'PUT',
            body: JSON.stringify({
                companyName: this.state.editSystemCompany.companyName,
                companyDisplayName: this.state.editSystemCompany.companyDisplayName,
                companyPortalDatabase: this.state.editSystemCompany.companyPortalDatabase,
                // companyDatabase: this.state.editSystemCompany.companyDatabase,
                companyLogo: this.state.editSystemCompany.companyLogo,
                companyUseSECData: this.state.editSystemCompany.companyUseSECData,
                companyActive: this.state.editSystemCompany.companyActive,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data) {
                    this.setState({
                        editSystemCompany: { ...this.blankSystemCompany },
                        unsavedChanges: false
                    }, () => {
                        this.props?.getCompanySettings();
                        this.getSystemCompanies();
                    });
                }
            });
    }

    render() {

        return (
            <Container fluid>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <CollapseCard title="System Companies" open={false} className="mt-0">
                    {(this.state.isLoaded === 1) && <SystemCompanies
                        clientToken={this.props.clientToken}
                        systemCompanies={this.state.systemCompanies}
                        newSystemCompany={this.state.newSystemCompany}
                        editSystemCompany={this.state.editSystemCompany}
                        isAdding={this.state.isAdding}
                        onChange={this.onChangeSystemCompany}
                        onEdit={this.onEditSystemCompany}
                        handleDelete={this.handleDeleteSystemCompany}
                        handleAdd={this.handleAddSystemCompany}
                        handleEdit={this.handleEditSystemCompany}
                        handleCancel={this.handleCancelSystemCompany}
                    />}
                </CollapseCard>
            </Container>
        );

    }
}

export default SystemCompaniesContainer;
